import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
const GetAllRecords = {
  name: 'advertisers',
  state: {
    data: [],
    all_data: [],
    allRecords: [],
    favorites: [],
    loading: false,
    error: '',
    totalCount: 0,
    tableHeaderDSO: [
      'Company Name',
      // 'Manager name',
      'Email',
      // 'Phone',
      'Industry',
      'Invited Displays',
      'Invited Zone',
      // 'Users',
      'Active Ads',

      // 'Status',
    ],
    tableHeader: [
      'Advertiser Name',
      'Email',
      'Industry',
      'Invited Displays',
      'Invited Zone',
      'Active Ads',
      'Account Manager',
    ],
    rpp: 10,
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
        all_data: [],
        totalCount: 0,
      };
    },
    getRecivedAllAdvsList(state, payload) {
      return {
        ...state,
        loading: false,
        error: '',
        data: payload.data,
        totalCount: payload.totalCount,
      };
    },
    toggleFavorite(state, payload) {
      const { id } = payload;
      const isFavorite = state.favorites.includes(id);

      return {
        ...state,
        favorites: isFavorite
          ? state.favorites.filter((favId) => favId !== id)
          : [...state.favorites, id],
      };
    },

    getReceived(state, payload) {
      const arr = [];
      payload.data.forEach((element) => {
        arr.push({
          id: element.id,
          org_name: element.org_name,
          name: { value: element.name, skip: true },
          email: element.email || '-',
          industry: element?.industry ? element.industry : 'No Industry',
          displays: element.displays,
          zones: element.zones,
          campaigns: element.campaigns,
          hasRate: element.hasRate,
          account_manager_id: element?.account_manager_id ?? null,
          account_manager_name: element?.account_manager_name ?? null,
          account_manager_email: element?.account_manager_email ?? null,
          account_manager: {
            type: 'account_manager',
            assigned: Boolean(element?.account_manager_id),
            name: element?.account_manager_name || null,
            email: element?.account_manager_email || null,
          },
        });
      });
      const records = [];
      payload.allRecords.forEach((element) => {
        records.push({
          id: element.id,
          org_name: element.org_name,
          name: element.name,
          email: element.email || '-',
          industry: element?.industry ? element.industry : 'No Industry',
          displays: element.displays,
          zones: element.zones,
          campaigns: element.campaigns,
          hasRate: element.hasRate,
        });
      });
      return {
        ...state,
        allRecords: records,
        all_data: arr,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },
    getReceivedAllAdvs(state, payload) {
      return {
        ...state,

        data: payload.data,
        loading: false,
        error: '',
        totalCount: payload.totalCount,
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getAllAdvs({ page, size }) {
      let url = `savvy/organization/get-advs-list/?page=${page}&size=${size}`;
      const response = await http.get(`${url}`);
      this.getRecivedAllAdvsList({
        data: response.data.data.rows,
        totalCount: response.data.data?.activeAdvertisers,
      });
    },
    async toggleFavoriteAdvertiser({ id }) {
      this.toggleFavorite({ id });
    },
    async getAll({ page, size, search, sorted_by, sort, selectFilter, rate, selectedRateScheduleId }) {
      try {
        this.getRequested();
        const isRate = rate === true ? true : false;
        let url = `savvy/organization/get-advs/?page=${page}&size=${size}&rate_id=${selectedRateScheduleId ? selectedRateScheduleId : 0}`;
        if (search && typeof search === 'string') {
          url = url + `&search="${search}"`;
        }
        if (sorted_by) {
          url = url + `&sorted_by=${sorted_by}`;
        }
        if (sort) {
          url = url + `&sort=${sort}`;
        }
        if (selectFilter?.industry?.length) {
          selectFilter.industry.forEach(ind => {
            url += `&industry[]=${encodeURIComponent(ind)}`;
          });
        }
        if(isRate) {
          url += `&isRate=true`;
        }else{
          url += `&isRate=false`;
        }

        const response = await http.get(url);
        this.getReceived({
          data: response.data.data.rows,
          totalCount: response.data.data?.activeAdvertisers,
          allRecords: response.data.data?.allData,
        });
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
    async getAllAdvsByDsos({ page, size, id }) {
      try {
        this.getRequested();
        const response = await http.get(
          `savvy/organization/getAdvByDsoId/${id}?page=${page}&size=${size}`
        );

        this.getReceivedAllAdvs({
          data: response.data.data.rows,
          totalCount: response.data.data.count,
        });
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default GetAllRecords;
